export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: Date; output: Date; }
};

export type AvailableOption = {
  __typename?: 'AvailableOption';
  bookingDays: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isBooking: Scalars['Boolean']['output'];
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceFrom?: Maybe<Scalars['Int']['output']>;
  shortname: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  type: OrderItemType;
};

export type CacheVersion = {
  __typename?: 'CacheVersion';
  clientId: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type Catalog = {
  __typename?: 'Catalog';
  contractor: Scalars['Int']['output'];
  selectable: Scalars['Boolean']['output'];
};

export type Config = {
  __typename?: 'Config';
  configKeys: Array<ConfigKey>;
};

export type ConfigKey = {
  __typename?: 'ConfigKey';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ConfirmedOrderItem = {
  __typename?: 'ConfirmedOrderItem';
  children: Array<ConfirmedOrderItemChild>;
  consumerCategory?: Maybe<ConsumerCategoryRef>;
  id: Scalars['Int']['output'];
  maxPublicPrice: Scalars['Int']['output'];
  participantId: Scalars['Int']['output'];
  product?: Maybe<OrderItemProduct>;
  startDate?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
  type: OrderItemType;
  variant: Variant;
};

export type ConfirmedOrderItemChild = {
  __typename?: 'ConfirmedOrderItemChild';
  consumerCategory?: Maybe<ConsumerCategoryRef>;
  id: Scalars['Int']['output'];
  maxPublicPrice: Scalars['Int']['output'];
  product?: Maybe<OrderItemProduct>;
  slug: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  type: OrderItemType;
  variant: Variant;
};

export type ConsumerCategory = {
  __typename?: 'ConsumerCategory';
  ageMax: Scalars['Int']['output'];
  ageMin: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  shortname: Scalars['String']['output'];
  student: Scalars['Boolean']['output'];
  visible: Scalars['Boolean']['output'];
};

export type ConsumerCategoryInput = {
  ageMax: Scalars['String']['input'];
  ageMin: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortname: Scalars['String']['input'];
  student: Scalars['Boolean']['input'];
  visible: Scalars['Boolean']['input'];
};

export type ConsumerCategoryRef = {
  __typename?: 'ConsumerCategoryRef';
  name?: Maybe<Scalars['String']['output']>;
  shortname: Scalars['String']['output'];
};

export type Contractor = {
  __typename?: 'Contractor';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum ControlStatus {
  Ko = 'KO',
  Ok = 'OK'
}

export type DynamicPriceDate = {
  __typename?: 'DynamicPriceDate';
  basePrice: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  remaining?: Maybe<Scalars['Int']['output']>;
  timeslotExternalId?: Maybe<Scalars['String']['output']>;
};

export type DynamicPrices = {
  __typename?: 'DynamicPrices';
  consumerCategoryShortname: Scalars['String']['output'];
  datesCollection: Array<DynamicPriceDate>;
};

export type ExclusionPeriod = {
  __typename?: 'ExclusionPeriod';
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type HubProduct = {
  __typename?: 'HubProduct';
  id: Scalars['ID']['output'];
  listing?: Maybe<Listing>;
  price?: Maybe<Price>;
  productCategoryShortname: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  taxons?: Maybe<Array<Taxon>>;
};

export type Image = {
  __typename?: 'Image';
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type Listing = {
  __typename?: 'Listing';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  title: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  confirmSimulation: Order;
  deleteOrder?: Maybe<Scalars['Boolean']['output']>;
  deleteOrderItem?: Maybe<Order>;
};


export type MutationConfirmSimulationArgs = {
  catalogSelectable: Scalars['Boolean']['input'];
  context: RequestContext;
  contractorId: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  participants: Array<ParticipantInput>;
  productCategoryShortname: Scalars['String']['input'];
  productCategoryVisible: Scalars['Boolean']['input'];
  validityCategoryShortname: Scalars['String']['input'];
  validityCategoryVisible: Scalars['Boolean']['input'];
};


export type MutationDeleteOrderArgs = {
  context: RequestContext;
  token: Scalars['String']['input'];
};


export type MutationDeleteOrderItemArgs = {
  context: RequestContext;
  orderItemId: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};

export type OptionInput = {
  slug: Scalars['String']['input'];
  timeslotExternalId?: InputMaybe<Scalars['String']['input']>;
};

export type Order = {
  __typename?: 'Order';
  createdAt?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  firstSkiDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  orderItems: Array<ConfirmedOrderItem>;
  promotions: Array<Promotion>;
  publicTotal?: Maybe<Scalars['Int']['output']>;
  state: OrderState;
  token: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  children: Array<OrderItemChild>;
  maxPublicPrice: Scalars['Int']['output'];
  participantId: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  type: OrderItemType;
  variant: Variant;
};

export type OrderItemChild = {
  __typename?: 'OrderItemChild';
  maxPublicPrice: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  type: OrderItemType;
  variant: Variant;
};

export type OrderItemProduct = {
  __typename?: 'OrderItemProduct';
  id: Scalars['Int']['output'];
  productCategory?: Maybe<ProductCategoryRef>;
  shortname?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  validityCategory?: Maybe<ValidityCategoryRef>;
};

export enum OrderItemType {
  Activity = 'ACTIVITY',
  Asset = 'ASSET',
  Insurance = 'INSURANCE',
  Insurancecancelation = 'INSURANCECANCELATION',
  Insuranceonce = 'INSURANCEONCE',
  Invoice = 'INVOICE',
  Managmentfee = 'MANAGMENTFEE',
  Package = 'PACKAGE',
  Shipping = 'SHIPPING',
  Skicase = 'SKICASE',
  Standard = 'STANDARD',
  Support = 'SUPPORT',
  Ticket = 'TICKET',
  Tollpassonce = 'TOLLPASSONCE'
}

export enum OrderState {
  Cancelled = 'CANCELLED',
  Cart = 'CART',
  Confirmed = 'CONFIRMED',
  Order = 'ORDER',
  Personalization = 'PERSONALIZATION'
}

export type ParticipantInput = {
  consumerCategory: ConsumerCategoryInput;
  date: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  options: Array<OptionInput>;
  productSlug: Scalars['String']['input'];
  timeslotExternalId?: InputMaybe<Scalars['String']['input']>;
};

export type Price = {
  __typename?: 'Price';
  currency: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type Prices = {
  __typename?: 'Prices';
  publicTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Product = {
  __typename?: 'Product';
  additionalInfo?: Maybe<ProductAdditionalInfo>;
  bookingDays: Array<Scalars['String']['output']>;
  calendarDisplay: Scalars['Boolean']['output'];
  catalog: Catalog;
  consumerCategories: Array<ConsumerCategory>;
  exclusionPeriods: Array<ExclusionPeriod>;
  firstSellableDate?: Maybe<Scalars['String']['output']>;
  hasDynamicPricing: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includedOptions: Array<Scalars['String']['output']>;
  isBooking: Scalars['Boolean']['output'];
  lastSellableDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productCategoryId: Scalars['Int']['output'];
  protectedByCode: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  validityCategory: ValidityCategory;
};

export type ProductAdditionalInfo = {
  __typename?: 'ProductAdditionalInfo';
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  additionalInfo?: Maybe<ProductCategoryAdditionalInfo>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  shortdesc?: Maybe<Scalars['String']['output']>;
  shortname: Scalars['String']['output'];
  validFrom: Scalars['AWSDateTime']['output'];
  validTo: Scalars['AWSDateTime']['output'];
  validities: Array<ProductCategoryValidity>;
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductCategoryAdditionalInfo = {
  __typename?: 'ProductCategoryAdditionalInfo';
  ctaBlockSubtitle?: Maybe<Scalars['String']['output']>;
  ctaBlockTitle?: Maybe<Scalars['String']['output']>;
  ctaButtonLabel?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  numBlackSlopes?: Maybe<Scalars['Int']['output']>;
  numBlueSlopes?: Maybe<Scalars['Int']['output']>;
  numGreenSlopes?: Maybe<Scalars['Int']['output']>;
  numKmSlope?: Maybe<Scalars['Int']['output']>;
  numRedSlopes?: Maybe<Scalars['Int']['output']>;
  numSkiLift?: Maybe<Scalars['Int']['output']>;
  numTotalSlopes?: Maybe<Scalars['Int']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export type ProductCategoryRef = {
  __typename?: 'ProductCategoryRef';
  name?: Maybe<Scalars['String']['output']>;
  shortname: Scalars['String']['output'];
};

export type ProductCategoryValidity = {
  __typename?: 'ProductCategoryValidity';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  shortname: Scalars['String']['output'];
  value: Scalars['Int']['output'];
  visible: Scalars['Boolean']['output'];
};

export type ProductCodeControlResponse = {
  __typename?: 'ProductCodeControlResponse';
  productCode: Scalars['String']['output'];
  status: ControlStatus;
};

export type Promotion = {
  __typename?: 'Promotion';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  contractors: Array<Contractor>;
  controlCode?: Maybe<ProductCodeControlResponse>;
  dynamicPrices: Array<DynamicPrices>;
  getCacheVersion: CacheVersion;
  getConfig?: Maybe<Config>;
  getOrder?: Maybe<Order>;
  hubProducts: Array<HubProduct>;
  productBySlug?: Maybe<Product>;
  productCategories: Array<ProductCategory>;
  productCategory: ProductCategory;
  productCategoryById?: Maybe<ProductCategory>;
  products: Array<Product>;
  simulation?: Maybe<Simulation>;
  timeslots?: Maybe<Array<Timeslot>>;
};


export type QueryContractorsArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryControlCodeArgs = {
  codeToControl: Scalars['String']['input'];
  context: RequestContext;
  productSlug: Scalars['String']['input'];
};


export type QueryDynamicPricesArgs = {
  consumerCategoryShortname: Scalars['String']['input'];
  context: RequestContext;
  fromDate: Scalars['String']['input'];
  nbDays: Scalars['Int']['input'];
  productSlug: Scalars['String']['input'];
  timeslotsExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetCacheVersionArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetConfigArgs = {
  context: RequestContext;
};


export type QueryGetOrderArgs = {
  context: RequestContext;
  token: Scalars['String']['input'];
};


export type QueryHubProductsArgs = {
  context: RequestContext;
};


export type QueryProductBySlugArgs = {
  context: RequestContext;
  productSlug: Scalars['String']['input'];
};


export type QueryProductCategoriesArgs = {
  context: RequestContext;
  contractorId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductCategoryArgs = {
  context: RequestContext;
  productCategoryShortname: Scalars['String']['input'];
  validityCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductCategoryByIdArgs = {
  context: RequestContext;
  productCategoryId: Scalars['Int']['input'];
  validityCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsArgs = {
  context: RequestContext;
  productCategoryShortname: Scalars['String']['input'];
};


export type QuerySimulationArgs = {
  catalogSelectable: Scalars['Boolean']['input'];
  context: RequestContext;
  contractorId: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  participants?: InputMaybe<Array<ParticipantInput>>;
  productCategoryShortname: Scalars['String']['input'];
  productCategoryVisible: Scalars['Boolean']['input'];
  validityCategoryShortname: Scalars['String']['input'];
  validityCategoryVisible: Scalars['Boolean']['input'];
};


export type QueryTimeslotsArgs = {
  context: RequestContext;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  productSlug: Scalars['String']['input'];
};

export type RequestContext = {
  cacheVersion?: InputMaybe<Scalars['Int']['input']>;
  clientId: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type Simulation = {
  __typename?: 'Simulation';
  availableOptions: Array<AvailableOption>;
  availableUpsellings: Array<UpsellProposal>;
  currency: Scalars['String']['output'];
  orderItems: Array<OrderItem>;
  prices: Prices;
  promotions: Array<Promotion>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _empty?: Maybe<Scalars['String']['output']>;
};

export type Taxon = {
  __typename?: 'Taxon';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Timeslot = {
  __typename?: 'Timeslot';
  dailyBooking: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  externalId: Scalars['String']['output'];
  limitQuotaOrderVel: Scalars['Int']['output'];
  quotaAvailable: Scalars['Int']['output'];
  quotaUnlimited: Scalars['Boolean']['output'];
};

export type UpsellProposal = {
  __typename?: 'UpsellProposal';
  description?: Maybe<Scalars['String']['output']>;
  hidePriceDifference: Scalars['Boolean']['output'];
  image?: Maybe<Scalars['String']['output']>;
  priceDifference: Scalars['Float']['output'];
  productCategoryShortname?: Maybe<Scalars['String']['output']>;
  productSlug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedFirstSkidate?: Maybe<Scalars['String']['output']>;
  validityCategoryShortname?: Maybe<Scalars['String']['output']>;
  validityCategoryValue?: Maybe<Scalars['Int']['output']>;
};

export type ValidityCategory = {
  __typename?: 'ValidityCategory';
  id: Scalars['Int']['output'];
  shortname: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type ValidityCategoryRef = {
  __typename?: 'ValidityCategoryRef';
  name?: Maybe<Scalars['String']['output']>;
  shortname: Scalars['String']['output'];
};

export type Variant = {
  __typename?: 'Variant';
  id: Scalars['ID']['output'];
  sku: Scalars['String']['output'];
};

export type ControlProductCodeQueryVariables = Exact<{
  productSlug: Scalars['String']['input'];
  codeToControl: Scalars['String']['input'];
  context: RequestContext;
}>;


export type ControlProductCodeQuery = { __typename?: 'Query', controlCode?: { __typename?: 'ProductCodeControlResponse', productCode: string, status: ControlStatus } | null };

export type GetTimeslotsQueryVariables = Exact<{
  productSlug: Scalars['String']['input'];
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  context: RequestContext;
}>;


export type GetTimeslotsQuery = { __typename?: 'Query', timeslots?: Array<{ __typename?: 'Timeslot', externalId: string, date: string, quotaAvailable: number, quotaUnlimited: boolean, dailyBooking: boolean, limitQuotaOrderVel: number, duration?: number | null }> | null };

export type GetProductCategoriesQueryVariables = Exact<{
  contractorId?: InputMaybe<Scalars['Int']['input']>;
  context: RequestContext;
}>;


export type GetProductCategoriesQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, shortname: string, additionalInfo?: { __typename?: 'ProductCategoryAdditionalInfo', description?: string | null, image: string, numBlackSlopes?: number | null, numBlueSlopes?: number | null, numGreenSlopes?: number | null, numKmSlope?: number | null, numRedSlopes?: number | null, numSkiLift?: number | null, numTotalSlopes?: number | null, shortDescription?: string | null } | null }> };

export type GetSimulationQueryVariables = Exact<{
  contractorId: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  productCategoryShortname: Scalars['String']['input'];
  validityCategoryShortname: Scalars['String']['input'];
  participants?: InputMaybe<Array<ParticipantInput> | ParticipantInput>;
  productCategoryVisible: Scalars['Boolean']['input'];
  validityCategoryVisible: Scalars['Boolean']['input'];
  catalogSelectable: Scalars['Boolean']['input'];
  context: RequestContext;
}>;


export type GetSimulationQuery = { __typename?: 'Query', simulation?: { __typename?: 'Simulation', currency: string, prices: { __typename?: 'Prices', publicTotal: number, total: number }, orderItems: Array<{ __typename?: 'OrderItem', participantId: number, maxPublicPrice: number, total: number, type: OrderItemType, variant: { __typename?: 'Variant', id: string, sku: string }, children: Array<{ __typename?: 'OrderItemChild', maxPublicPrice: number, total: number, type: OrderItemType, slug: string, variant: { __typename?: 'Variant', id: string, sku: string } }> }>, promotions: Array<{ __typename?: 'Promotion', id: number, name: string, description: string }>, availableOptions: Array<{ __typename?: 'AvailableOption', slug: string, shortname: string, description?: string | null, mandatory: boolean, name: string, priceFrom?: number | null, type: OrderItemType, isBooking: boolean, bookingDays: Array<string>, tags: Array<string> }>, availableUpsellings: Array<{ __typename?: 'UpsellProposal', productSlug: string, title: string, description?: string | null, priceDifference: number, hidePriceDifference: boolean, updatedFirstSkidate?: string | null, image?: string | null, validityCategoryValue?: number | null, productCategoryShortname?: string | null, validityCategoryShortname?: string | null }> } | null };

export type GetProductCategoryQueryVariables = Exact<{
  productCategoryShortname: Scalars['String']['input'];
  validityCategoryId?: InputMaybe<Scalars['Int']['input']>;
  context: RequestContext;
}>;


export type GetProductCategoryQuery = { __typename?: 'Query', productCategory: { __typename?: 'ProductCategory', id: number, name: string, shortname: string, visible?: boolean | null, validFrom: Date, validTo: Date, validities: Array<{ __typename?: 'ProductCategoryValidity', id: number, name?: string | null, position: number, shortname: string, value: number, visible: boolean }>, additionalInfo?: { __typename?: 'ProductCategoryAdditionalInfo', description?: string | null, numBlackSlopes?: number | null, numBlueSlopes?: number | null, numGreenSlopes?: number | null, numKmSlope?: number | null, numRedSlopes?: number | null, numSkiLift?: number | null, numTotalSlopes?: number | null, tagline?: string | null, image: string, ctaBlockTitle?: string | null, ctaBlockSubtitle?: string | null, ctaButtonLabel?: string | null } | null } };

export type GetProductCategoryByIdQueryVariables = Exact<{
  productCategoryId: Scalars['Int']['input'];
  validityCategoryId?: InputMaybe<Scalars['Int']['input']>;
  context: RequestContext;
}>;


export type GetProductCategoryByIdQuery = { __typename?: 'Query', productCategoryById?: { __typename?: 'ProductCategory', id: number, name: string, shortname: string, visible?: boolean | null, validFrom: Date, validTo: Date, validities: Array<{ __typename?: 'ProductCategoryValidity', id: number, name?: string | null, position: number, shortname: string, value: number, visible: boolean }>, additionalInfo?: { __typename?: 'ProductCategoryAdditionalInfo', description?: string | null, numBlackSlopes?: number | null, numBlueSlopes?: number | null, numGreenSlopes?: number | null, numKmSlope?: number | null, numRedSlopes?: number | null, numSkiLift?: number | null, numTotalSlopes?: number | null, tagline?: string | null, image: string, ctaBlockTitle?: string | null, ctaBlockSubtitle?: string | null, ctaButtonLabel?: string | null } | null } | null };

export type GetProductsQueryVariables = Exact<{
  productCategoryShortname: Scalars['String']['input'];
  context: RequestContext;
}>;


export type GetProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, calendarDisplay: boolean, slug: string, name: string, protectedByCode: boolean, isBooking: boolean, bookingDays: Array<string>, hasDynamicPricing: boolean, includedOptions: Array<string>, firstSellableDate?: string | null, lastSellableDate?: string | null, productCategoryId: number, exclusionPeriods: Array<{ __typename?: 'ExclusionPeriod', startDate: string, endDate: string }>, consumerCategories: Array<{ __typename?: 'ConsumerCategory', ageMax: number, ageMin: number, name: string, shortname: string, student: boolean, visible: boolean, position: number }>, additionalInfo?: { __typename?: 'ProductAdditionalInfo', shortDescription?: string | null } | null, catalog: { __typename?: 'Catalog', contractor: number, selectable: boolean }, validityCategory: { __typename?: 'ValidityCategory', id: number, shortname: string, visible: boolean } }> };

export type GetProductBySlugQueryVariables = Exact<{
  productSlug: Scalars['String']['input'];
  context: RequestContext;
}>;


export type GetProductBySlugQuery = { __typename?: 'Query', productBySlug?: { __typename?: 'Product', id: string, calendarDisplay: boolean, slug: string, name: string, protectedByCode: boolean, isBooking: boolean, bookingDays: Array<string>, hasDynamicPricing: boolean, includedOptions: Array<string>, firstSellableDate?: string | null, lastSellableDate?: string | null, productCategoryId: number, exclusionPeriods: Array<{ __typename?: 'ExclusionPeriod', startDate: string, endDate: string }>, consumerCategories: Array<{ __typename?: 'ConsumerCategory', ageMax: number, ageMin: number, name: string, shortname: string, student: boolean, visible: boolean, position: number }>, additionalInfo?: { __typename?: 'ProductAdditionalInfo', shortDescription?: string | null } | null, catalog: { __typename?: 'Catalog', contractor: number, selectable: boolean }, validityCategory: { __typename?: 'ValidityCategory', id: number, shortname: string, visible: boolean } } | null };

export type GetDynamicPricesQueryVariables = Exact<{
  productSlug: Scalars['String']['input'];
  fromDate: Scalars['String']['input'];
  nbDays: Scalars['Int']['input'];
  consumerCategoryShortname: Scalars['String']['input'];
  timeslotsExternalIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  context: RequestContext;
}>;


export type GetDynamicPricesQuery = { __typename?: 'Query', dynamicPrices: Array<{ __typename?: 'DynamicPrices', consumerCategoryShortname: string, datesCollection: Array<{ __typename?: 'DynamicPriceDate', date: string, basePrice: number, price: number, remaining?: number | null, timeslotExternalId?: string | null }> }> };

export type GetContractorsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContractorsQuery = { __typename?: 'Query', contractors: Array<{ __typename?: 'Contractor', id: number, name: string, slug: string }> };

export type GetHubProductsQueryVariables = Exact<{
  context: RequestContext;
}>;


export type GetHubProductsQuery = { __typename?: 'Query', hubProducts: Array<{ __typename?: 'HubProduct', id: string, slug: string, productCategoryShortname: string, listing?: { __typename?: 'Listing', title: string, description?: string | null, image?: { __typename?: 'Image', thumbnailUrl?: string | null } | null } | null, price?: { __typename?: 'Price', currency: string, value: number } | null, taxons?: Array<{ __typename?: 'Taxon', code: string, name: string }> | null }> };

export type OrderFieldsFragment = { __typename?: 'Order', id: number, token: string, state: OrderState, total: number, publicTotal?: number | null, currency: string, firstSkiDate?: string | null, expiresAt?: string | null, createdAt?: string | null, orderItems: Array<{ __typename?: 'ConfirmedOrderItem', id: number, participantId: number, total: number, maxPublicPrice: number, type: OrderItemType, startDate?: string | null, product?: { __typename?: 'OrderItemProduct', id: number, slug: string, shortname?: string | null, productCategory?: { __typename?: 'ProductCategoryRef', shortname: string, name?: string | null } | null, validityCategory?: { __typename?: 'ValidityCategoryRef', shortname: string, name?: string | null } | null } | null, variant: { __typename?: 'Variant', id: string, sku: string }, consumerCategory?: { __typename?: 'ConsumerCategoryRef', shortname: string, name?: string | null } | null, children: Array<{ __typename?: 'ConfirmedOrderItemChild', id: number, total: number, maxPublicPrice: number, type: OrderItemType, slug: string, product?: { __typename?: 'OrderItemProduct', id: number, slug: string, shortname?: string | null } | null, variant: { __typename?: 'Variant', id: string, sku: string }, consumerCategory?: { __typename?: 'ConsumerCategoryRef', shortname: string, name?: string | null } | null }> }>, promotions: Array<{ __typename?: 'Promotion', id: number, name: string, description: string }> };

export type ConfirmSimulationMutationVariables = Exact<{
  contractorId: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  productCategoryShortname: Scalars['String']['input'];
  validityCategoryShortname: Scalars['String']['input'];
  participants: Array<ParticipantInput> | ParticipantInput;
  productCategoryVisible: Scalars['Boolean']['input'];
  validityCategoryVisible: Scalars['Boolean']['input'];
  catalogSelectable: Scalars['Boolean']['input'];
  context: RequestContext;
}>;


export type ConfirmSimulationMutation = { __typename?: 'Mutation', confirmSimulation: { __typename?: 'Order', id: number, token: string, state: OrderState, total: number, publicTotal?: number | null, currency: string, firstSkiDate?: string | null, expiresAt?: string | null, createdAt?: string | null, orderItems: Array<{ __typename?: 'ConfirmedOrderItem', id: number, participantId: number, total: number, maxPublicPrice: number, type: OrderItemType, startDate?: string | null, product?: { __typename?: 'OrderItemProduct', id: number, slug: string, shortname?: string | null, productCategory?: { __typename?: 'ProductCategoryRef', shortname: string, name?: string | null } | null, validityCategory?: { __typename?: 'ValidityCategoryRef', shortname: string, name?: string | null } | null } | null, variant: { __typename?: 'Variant', id: string, sku: string }, consumerCategory?: { __typename?: 'ConsumerCategoryRef', shortname: string, name?: string | null } | null, children: Array<{ __typename?: 'ConfirmedOrderItemChild', id: number, total: number, maxPublicPrice: number, type: OrderItemType, slug: string, product?: { __typename?: 'OrderItemProduct', id: number, slug: string, shortname?: string | null } | null, variant: { __typename?: 'Variant', id: string, sku: string }, consumerCategory?: { __typename?: 'ConsumerCategoryRef', shortname: string, name?: string | null } | null }> }>, promotions: Array<{ __typename?: 'Promotion', id: number, name: string, description: string }> } };

export type GetOrderQueryVariables = Exact<{
  token: Scalars['String']['input'];
  context: RequestContext;
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'Order', id: number, token: string, state: OrderState, total: number, publicTotal?: number | null, currency: string, firstSkiDate?: string | null, expiresAt?: string | null, createdAt?: string | null, orderItems: Array<{ __typename?: 'ConfirmedOrderItem', id: number, participantId: number, total: number, maxPublicPrice: number, type: OrderItemType, startDate?: string | null, product?: { __typename?: 'OrderItemProduct', id: number, slug: string, shortname?: string | null, productCategory?: { __typename?: 'ProductCategoryRef', shortname: string, name?: string | null } | null, validityCategory?: { __typename?: 'ValidityCategoryRef', shortname: string, name?: string | null } | null } | null, variant: { __typename?: 'Variant', id: string, sku: string }, consumerCategory?: { __typename?: 'ConsumerCategoryRef', shortname: string, name?: string | null } | null, children: Array<{ __typename?: 'ConfirmedOrderItemChild', id: number, total: number, maxPublicPrice: number, type: OrderItemType, slug: string, product?: { __typename?: 'OrderItemProduct', id: number, slug: string, shortname?: string | null } | null, variant: { __typename?: 'Variant', id: string, sku: string }, consumerCategory?: { __typename?: 'ConsumerCategoryRef', shortname: string, name?: string | null } | null }> }>, promotions: Array<{ __typename?: 'Promotion', id: number, name: string, description: string }> } | null };

export type DeleteOrderMutationVariables = Exact<{
  token: Scalars['String']['input'];
  context: RequestContext;
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder?: boolean | null };

export type DeleteOrderItemMutationVariables = Exact<{
  token: Scalars['String']['input'];
  orderItemId: Scalars['Int']['input'];
  context: RequestContext;
}>;


export type DeleteOrderItemMutation = { __typename?: 'Mutation', deleteOrderItem?: { __typename?: 'Order', id: number, token: string, state: OrderState, total: number, publicTotal?: number | null, currency: string, firstSkiDate?: string | null, expiresAt?: string | null, createdAt?: string | null, orderItems: Array<{ __typename?: 'ConfirmedOrderItem', id: number, participantId: number, total: number, maxPublicPrice: number, type: OrderItemType, startDate?: string | null, product?: { __typename?: 'OrderItemProduct', id: number, slug: string, shortname?: string | null, productCategory?: { __typename?: 'ProductCategoryRef', shortname: string, name?: string | null } | null, validityCategory?: { __typename?: 'ValidityCategoryRef', shortname: string, name?: string | null } | null } | null, variant: { __typename?: 'Variant', id: string, sku: string }, consumerCategory?: { __typename?: 'ConsumerCategoryRef', shortname: string, name?: string | null } | null, children: Array<{ __typename?: 'ConfirmedOrderItemChild', id: number, total: number, maxPublicPrice: number, type: OrderItemType, slug: string, product?: { __typename?: 'OrderItemProduct', id: number, slug: string, shortname?: string | null } | null, variant: { __typename?: 'Variant', id: string, sku: string }, consumerCategory?: { __typename?: 'ConsumerCategoryRef', shortname: string, name?: string | null } | null }> }>, promotions: Array<{ __typename?: 'Promotion', id: number, name: string, description: string }> } | null };

export type ConfiguratorQueryVariables = Exact<{
  context: RequestContext;
}>;


export type ConfiguratorQuery = { __typename?: 'Query', getConfig?: { __typename?: 'Config', configKeys: Array<{ __typename?: 'ConfigKey', id: string, value: string }> } | null };

export type GetCacheVersionQueryVariables = Exact<{
  clientId: Scalars['String']['input'];
}>;


export type GetCacheVersionQuery = { __typename?: 'Query', getCacheVersion: { __typename?: 'CacheVersion', clientId: string, version: number } };
